module.exports = __webpack_public_path__ + "media/extras/shop-empty-state-illustration-65d6e12a.svg";